const market = {
    dsbz: '上場予定通貨',
    kpsj: 'オープンまでのカウントダウン/オープン時間',
	ykp: 'すでにオープン',
    kpdjs: 'オープニングカウントダウン',
    worning: '最終取引価格ではありません、参考までに',
    swapTab_1: 'USDT本位先物',
    swapTab_2: 'コイン本位先物',
    searchCoin: '検索するコイン',
    risk: 'リスク警告',
    addSelfCode: 'お気に入りに追加',
    pair: 'コインペア',
    latestPrice: '最新価格',
    changeHour: '変動幅',
    highHour: '24時間最高',
    lowHour: '24時間最低',
    priceTrend: '価格トレンド（3日間）',
    volumeHour: '24時間取引量',
    noSearch: '該当するコインはありません',
    noAdd: 'お気に入りに追加されていません',
    noYet: 'このコインはまだ対応していません',
    noBi: 'このコインはまだ上場していません',
    wan: '万',
    qian: '千',
    yi: '億',
    yxhy: '無期限先物',
	wghy: 'グリッド契約',
    cxjy:
        'イノベーションエリアのコインは技術や市場などで一定の実績がありますが、価格の変動が大きく、リスクも比較的高いです。関連情報を注意深く確認し、ご自身のリスク許容範囲を再考する上、参加するかどうかをお決めください。',
    qljy:
        'ポテンシャル取引エリアは市場の成長初期段階にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身がリスク許容範囲内で慎重に投資することをお勧めします。',
    qljyDao: 'DAO取引エリアは市場の成長初期段階にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身のリスク許容範囲内で慎重に投資することをお勧めします。',
    default: '取引エリアは市場の成長初期段階にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身のリスク許容範囲内で慎重に投資することをお勧めします。',
    storage: 'ストレージ取引エリアは市場の成長初期段階にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身のリスク許容範囲内で慎重に投資することをお勧めします。',
    dlt: '低流通エリアはデジタル資産市場の流動性が低く、上場廃止するリスクがあります。投資前に慎重に検討することをお勧めします。',
    defi: 'DeFi取引エリアは市場の成長初期段階にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身のリスク許容範囲内で慎重に投資することをお勧めします。',
    nft: 'NFT取引エリアは市場の成長初期段階期にあり、BiKingはその市場価値と流通状況に対して保証することはできません。プロジェクト情報を詳しく調べ、自身のリスク許容範囲内で慎重に投資することをお勧めします。',
    hz: '無期限',
    yx: '厳選',
    yjyzx: '研究機構の選定プロジェクト',
    zx: 'お気に入り',
    bb: '現物',
    hy: '先物',
    zfb: '上昇幅ランキング',
    xbb: '新規コインランキング',
    bd: 'コインペア',
    zxj: '最新価格',
    zdf24: '24時間変動幅',
    high24: '24時間最高',
    low24: '24時間最低',
    turnover24: '24時間取引量',
    zd24: '24時間変動',
    zjrzd: '価格/日変動',
    scgl: '市場概要',
    jysj: 'トランザクションデータ',
    fyje: "コミッション金額",
    推荐链接:'リンク',
    一键分享:'ワンクリックで共有',
    是否交易:'取引するかどうか',
	推荐好友:'友達を勧める',
    推荐: "紹介",
	合约交易返佣:'高額な契約取引でリベートを獲得',
	我的返佣比例:'私のリベート率',
	好友返佣比例:'フレンドリベート率',
	推荐码:'紹介コード',
	交易人数:'トランザクション数',
	推荐总览:'推奨される概要',
	推荐人数:'推奨人数',
	合约返佣:'契約リベート',
	推荐记录:'おすすめレコード',
	返佣记录:'委託記録',
	请输入账户UID:'アカウントUIDを入力してください',
	账户UID:'アカウントUID',
	注册时间:'登録時刻 (UTC+8)',
	合约手续费:'契約事務手数料',
	返佣活动规则说明:'リベートアクティビティルールの説明:',
	使用你的推荐链接:'紹介リンクまたはコードを使用して登録したユーザーは、登録時に紹介コードを入力しない場合、招待者とみなされます。',
	被邀请人产生的真实交易手续费:'招待者が発生した実際の取引手数料について、招待者は取引手数料に相当する手数料を受け取ることができ、翌日には招待者の口座に返金されます。具体的な入金時間は毎日 4 時以降となります。',
	被邀请人只有进行合约:'招待者による契約取引の手数料のみが手数料リベートに含まれます。',
	用户邀请朋友无上限:'ユーザーが友達を招待できる上限はありません。招待者による契約取引の手数料のみが手数料リベートに含まれます。',
	不允许任何用户通过多:'ユーザーは複数のアカウントを介して自己招待することはできません。認証が完了すると、すべてのリベートがキャンセルされ、招待されたアカウントの手数料リベートもキャンセルされます。',
	由于市场环境的改变:'市場環境の変化、詐欺リスクの存在、その他の理由により、Biking はいつでもリベート ルールを調整する最終的な権利を留保します。',
	保留对活动的最终解释权:'ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。',
    ms: "はい",
    mf: "いいえ",
};

export { market };


// WEBPACK FOOTER //
// ./src/i18n/lang/market/ja_JP.js